import { render, staticRenderFns } from "./PollPost.vue?vue&type=template&id=28bde4bd&"
import script from "./PollPost.vue?vue&type=script&lang=ts&"
export * from "./PollPost.vue?vue&type=script&lang=ts&"
import style0 from "./PollPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports